import { call, put, takeLatest } from 'redux-saga/effects';
import * as api from 'api/resetPhone/resetPhone';
import { DO_RESET_PHONE_NUMBER, GET_USER_BY_PHONE } from 'state/actionTypes';
import * as toastActions from 'state/toast/actions';
import { setUserDetail } from 'state/resetPhone/actions';

export function* getUserByPhoneSaga({ payload }) {
  try {
    const response = yield call(api.getUserByPhoneNumber, payload);
    yield put(setUserDetail(response.data.data));
  } catch (error) {
    const response = {
      data: {},
    };
    yield put(setUserDetail(response));
    yield put(toastActions.errorMessage('Failed to get user', error.message));
  }
}

export function* resetPhoneNumberSaga({ payload }) {
  const { userId, phoneNumber } = payload;

  try {
    yield call(api.performResetPhoneNumber, {
      user_id: userId,
      phone_number: phoneNumber,
    });
    yield put(toastActions.successMessage(`Successfully reset phone number`));
  } catch (error) {
    yield put(
      toastActions.errorMessage('Failed to reset phone number', error.message)
    );
  }
}

export default function*() {
  yield takeLatest(GET_USER_BY_PHONE, getUserByPhoneSaga);
  yield takeLatest(DO_RESET_PHONE_NUMBER, resetPhoneNumberSaga);
}
